import React from 'react';
import PropTypes from 'prop-types';
import { RightSideBar } from '../../../../../../newContainers';
import { ScrollWrapper, TabWrapper } from '../../../../../../ui-kit';
import ContactSummary from '../contactSummary';
import PinnedContacts from '../pinnedContacts';
import { TabWrapperMobile } from '../../../../../../newContainers/rightSideBar/components';
import './style.sass';

const RightSideBarContainer = ({
  t, setActiveTabTitle, activeTabTitle,
}) => (
  <>
    <RightSideBar className="right-side-bar--projects" title={t('Contacts summary')}>
      <ScrollWrapper className="right-side-bar__scroll-wrapper">
        <ContactSummary />
        <TabWrapper
          title={<h2 className="title">Pinned contacts</h2>}
        >
          <PinnedContacts />
        </TabWrapper>
      </ScrollWrapper>
      <ScrollWrapper className="right-side-bar__scroll-wrapper">
        <ContactSummary />
        <TabWrapperMobile
          setActiveTitle={setActiveTabTitle}
          title="Pinned contacts"
          active={activeTabTitle}
        >
          <PinnedContacts />
        </TabWrapperMobile>
      </ScrollWrapper>
    </RightSideBar>
  </>
);

RightSideBarContainer.propTypes = {
  windowWidth: PropTypes.number.isRequired,
  activeTabTitle: PropTypes.string,
  t: PropTypes.func.isRequired,
  setActiveTabTitle: PropTypes.func.isRequired,
};
RightSideBarContainer.defaultProps = {
  activeTabTitle: '',
};

export default RightSideBarContainer;
